"use strict";
// DEPRECATION NOTICE: prefer TimelineBodyWrapper (once TimelineBodyEditor is available) CRM-Issues/3655
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _BodyContent = _interopRequireDefault(require("crm_ui/timeline/components/generic/BodyContent"));

var _AttachmentThumbnailUrlConfig = _interopRequireDefault(require("customer-data-communicator/data/attachments/AttachmentThumbnailUrlConfig"));

var _AttachmentsList = _interopRequireDefault(require("customer-data-email/components/attachments/AttachmentsList"));

var _RemovableAttachments = _interopRequireDefault(require("crm_ui/timeline/components/events/note/RemovableAttachments"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _TimelineEditableSection = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineEditableSection"));

var _UIExpandableText = _interopRequireDefault(require("UIComponents/text/UIExpandableText"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _colors = require("HubStyleTokens/colors");

var _TimelineCardConstants = require("crm_ui/timeline/components/generic/TimelineCardConstants");

var _SanitizeHelper = require("crm_ui/utils/SanitizeHelper");

var _Sanitize = require("sanitize-text/sanitizers/Sanitize");

var _reactDom = require("react-dom");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var MAX_HEIGHT_REMS_DEFAULT = 8;
var FADE_OUT_REMS_DEFAULT = 2;

var TimelineBody =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineBody, _PureComponent);

  function TimelineBody() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineBody);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineBody).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isExpanded: false,
      collapsible: false,
      isShowingEditOverlay: false,
      dragDistance: 0,
      clickPos: 0
    };
    _this.onElementMount = _this.onElementMount.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TimelineBody, [{
    key: "onElementMount",
    value: function onElementMount(ref) {
      this._elementRef = (0, _reactDom.findDOMNode)(ref);
    }
  }, {
    key: "isBodyEmpty",
    value: function isBodyEmpty() {
      var body = this.props.body;
      return !body || (0, _SanitizeHelper.getText)(body) === '' && !(0, _Sanitize.hasImage)(body);
    }
  }, {
    key: "hasChildren",
    value: function hasChildren() {
      var hasChildren = false;

      _react.Children.forEach(this.props.children, function (child) {
        if (child) {
          hasChildren = true;
        }
      });

      return hasChildren;
    }
  }, {
    key: "getExpandText",
    value: function getExpandText() {
      var text = this.state.isExpanded ? 'collapse' : 'expand';
      return _react.default.createElement(_FormattedMessage.default, {
        message: "profileContentTimeline." + text
      });
    }
  }, {
    key: "handleToggleExpand",
    value: function handleToggleExpand() {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: "handleCollapsibleChange",
    value: function handleCollapsibleChange() {
      if (!this._elementRef) {
        return;
      }

      var isCollapsible = this._elementRef.getAttribute('data-collapsible') === 'true';
      this.setState({
        collapsible: isCollapsible
      });
    }
  }, {
    key: "handleOnMouseDown",
    value: function handleOnMouseDown(e) {
      var clickPos = !e.target.href ? e.screenX : 0;
      this.setState({
        clickPos: clickPos
      });
    }
  }, {
    key: "handleOnMouseLeave",
    value: function handleOnMouseLeave() {
      this.setState({
        dragDistance: 0,
        clickPos: 0
      });
    }
  }, {
    key: "handleOnMouseMove",
    value: function handleOnMouseMove(e) {
      var dragDistance = this.state.clickPos === 0 ? 0 : Math.abs(e.screenX - this.state.clickPos);
      this.setState({
        dragDistance: dragDistance
      });
    }
  }, {
    key: "handleOnMouseUp",
    value: function handleOnMouseUp() {
      var _this$props = this.props,
          isEditable = _this$props.isEditable,
          canEdit = _this$props.canEdit,
          onToggleEditBody = _this$props.onToggleEditBody;

      if (this.state.clickPos !== 0 && this.state.dragDistance <= 5 && isEditable && canEdit) {
        onToggleEditBody();
      }

      this.handleOnMouseLeave();
    }
  }, {
    key: "handleEditableSectionMouseEnter",
    value: function handleEditableSectionMouseEnter() {
      this.setState({
        isShowingEditOverlay: true
      });
    }
  }, {
    key: "handleEditableSectionMouseLeave",
    value: function handleEditableSectionMouseLeave() {
      this.setState({
        isShowingEditOverlay: false
      });
    }
  }, {
    key: "renderBodyContentEmptyState",
    value: function renderBodyContentEmptyState() {
      if (!this.props.canEdit) {
        return null;
      }

      return _react.default.createElement(_FormattedMessage.default, {
        style: {
          color: _colors.EERIE
        },
        message: "profileContentTimeline.addDescription"
      });
    }
  }, {
    key: "renderBodyContent",
    value: function renderBodyContent() {
      var _this$props2 = this.props,
          body = _this$props2.body,
          linkTwitter = _this$props2.linkTwitter,
          plainText = _this$props2.plainText,
          sanitizeConfig = _this$props2.sanitizeConfig,
          dataSeleniumKey = _this$props2.dataSeleniumKey;
      var isExpanded = this.state.isExpanded;
      return _react.default.createElement(_BodyContent.default, {
        plainText: plainText,
        body: body,
        isExpanded: isExpanded,
        linkTwitter: linkTwitter,
        dataSeleniumKey: dataSeleniumKey,
        sanitizeConfig: sanitizeConfig
      });
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props3 = this.props,
          body = _this$props3.body,
          plainText = _this$props3.plainText,
          isHovering = _this$props3.isHovering,
          isEditable = _this$props3.isEditable,
          canEdit = _this$props3.canEdit;
      var isExpanded = this.state.isExpanded;

      if (this.isBodyEmpty() && !plainText) {
        return this.renderBodyContentEmptyState();
      }

      var expandedClassName = (0, _classnames.default)({
        'overflow-x-auto': isExpanded
      });
      var showEditOverlay = isHovering && isEditable && canEdit;

      if ((!body || !(0, _Sanitize.hasImage)(body)) && (plainText && plainText.length < 350 || body && body.length < 350)) {
        return this.renderBodyContent();
      }

      return _react.default.createElement(_UIExpandableText.default, {
        gradientColor: showEditOverlay && this.state.isShowingEditOverlay ? _colors.CALYPSO_LIGHT : null,
        className: expandedClassName,
        expanded: this.state.isExpanded,
        fadeOutHeightRems: this.props.fadeOutHeightRems,
        maxHeightRems: this.props.maxHeightRems,
        toggleable: false,
        onCollapsibleChange: this.handleCollapsibleChange,
        ref: this.onElementMount
      }, this.renderBodyContent());
    }
  }, {
    key: "renderEditableSection",
    value: function renderEditableSection() {
      var _this$props4 = this.props,
          isHovering = _this$props4.isHovering,
          isEditable = _this$props4.isEditable,
          canEdit = _this$props4.canEdit;
      var showEditOverlay = isHovering && isEditable && canEdit;

      if (!isEditable && this.isBodyEmpty() && !this.props.plainText) {
        return null;
      }

      return _react.default.createElement(_TimelineEditableSection.default, {
        showEditOverlay: showEditOverlay,
        onMouseEnter: this.handleEditableSectionMouseEnter,
        onMouseLeave: this.handleEditableSectionMouseLeave,
        onToggleEditBody: this.props.onToggleEditBody
      }, _react.default.createElement("div", {
        onMouseDown: this.handleOnMouseDown,
        onMouseLeave: this.handleOnMouseLeave,
        onMouseMove: this.handleOnMouseMove,
        onMouseUp: this.handleOnMouseUp
      }, this.renderBody(), this.renderAttachments()));
    }
  }, {
    key: "renderExpandButton",
    value: function renderExpandButton() {
      if (!this.props.toggleable || !this.state.collapsible) {
        return null;
      }

      return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIButton.default, {
        onClick: this.handleToggleExpand,
        use: "link"
      }, this.getExpandText()));
    }
  }, {
    key: "renderAttachments",
    value: function renderAttachments() {
      var _this$props5 = this.props,
          attachments = _this$props5.attachments,
          showRemovableAttachments = _this$props5.showRemovableAttachments;

      if (!attachments || !attachments.size || showRemovableAttachments) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "p-y-2"
      }, _react.default.createElement(_AttachmentsList.default, {
        useDefaultPadding: false,
        hasInteractions: true,
        childClassName: "p-left-0 p-right-2",
        attachments: this.props.attachments,
        thumbnailUrlConfig: _AttachmentThumbnailUrlConfig.default
      }));
    }
  }, {
    key: "renderRemovableAttachments",
    value: function renderRemovableAttachments() {
      var _this$props6 = this.props,
          attachments = _this$props6.attachments,
          engagement = _this$props6.engagement,
          canEdit = _this$props6.canEdit,
          showRemovableAttachments = _this$props6.showRemovableAttachments;

      if (!attachments || !attachments.size || !showRemovableAttachments) {
        return null;
      }

      return _react.default.createElement(_RemovableAttachments.default, {
        attachments: attachments,
        engagement: engagement,
        canEdit: canEdit
      });
    }
  }, {
    key: "renderChildrenSection",
    value: function renderChildrenSection() {
      if (!this.hasChildren()) {
        return null;
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'p-bottom-4': !this.props.disableChildPadding
        }),
        "data-unit-test": "timeline-body-children"
      }, this.props.children);
    }
  }, {
    key: "renderBelowBodyContentSection",
    value: function renderBelowBodyContentSection() {
      var belowBodyContent = this.props.belowBodyContent;

      if (!belowBodyContent) {
        return null;
      }

      return _react.default.createElement("div", {
        "data-unit-test": "timeline-body-below-content"
      }, belowBodyContent);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      return _react.default.createElement("div", {
        className: (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, _TimelineCardConstants.TIMELINE_CARD_LEFT_PADDING, this.props.useDefaultPadding), (0, _defineProperty2.default)(_classNames, _TimelineCardConstants.TIMELINE_CARD_RIGHT_PADDING, this.props.useDefaultPadding), _classNames), this.props.className)
      }, this.renderChildrenSection(), this.renderEditableSection(), this.renderExpandButton(), this.renderRemovableAttachments(), this.renderBelowBodyContentSection());
    }
  }]);
  return TimelineBody;
}(_PureComponent2.default);

TimelineBody.propTypes = {
  body: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  dataSeleniumKey: _propTypes.default.string,
  disableChildPadding: _propTypes.default.bool,
  onToggleEditBody: _propTypes.default.func,
  engagement: _propTypes.default.instanceOf(_EngagementRecord.default),
  fadeOutHeightRems: _propTypes.default.number,
  isEditable: _propTypes.default.bool,
  showRemovableAttachments: _propTypes.default.bool,
  isHovering: _propTypes.default.bool,
  linkTwitter: _propTypes.default.bool.isRequired,
  maxHeightRems: _propTypes.default.number,
  plainText: _propTypes.default.string,
  sanitizeConfig: _propTypes.default.object,
  toggleable: _propTypes.default.bool,
  belowBodyContent: _propTypes.default.node,
  attachments: _reactImmutableProptypes.default.list,
  canEdit: _propTypes.default.bool,
  useDefaultPadding: _propTypes.default.bool
};
TimelineBody.defaultProps = {
  onToggleEditBody: _emptyFunction.default,
  disableChildPadding: false,
  fadeOutHeightRems: FADE_OUT_REMS_DEFAULT,
  showRemovableAttachments: false,
  isEditable: false,
  linkTwitter: false,
  maxHeightRems: MAX_HEIGHT_REMS_DEFAULT,
  toggleable: true,
  isHovering: false,
  useDefaultPadding: true,
  canEdit: true
};
var _default = TimelineBody;
exports.default = _default;
module.exports = exports.default;